import React from 'react';
export default function userCircle(props) {
  return (
<svg xmlns="http://www.w3.org/2000/svg" style={props.style} viewBox="0 0 72.656 72.656">
  <path d="M36.328-64.453A36.322,36.322,0,0,0,0-28.125,36.322,36.322,0,0,0,36.328,8.2,36.322,36.322,0,0,0,72.656-28.125,36.322,36.322,0,0,0,36.328-64.453Zm0,14.062A12.891,12.891,0,0,1,49.219-37.5,12.891,12.891,0,0,1,36.328-24.609,12.891,12.891,0,0,1,23.437-37.5,12.891,12.891,0,0,1,36.328-50.391ZM36.328,0a28.07,28.07,0,0,1-21.46-9.99A16.332,16.332,0,0,1,29.3-18.75a3.587,3.587,0,0,1,1.04.161,19.394,19.394,0,0,0,5.991,1.011,19.321,19.321,0,0,0,5.991-1.011,3.587,3.587,0,0,1,1.04-.161A16.332,16.332,0,0,1,57.788-9.99,28.07,28.07,0,0,1,36.328,0Z" transform="translate(0 64.453)"/>
</svg>)
}

